import LoaderComponent from "../LoaderComponent/LoaderComponent";
import "./_spinner.scss";
function Spinner() {
  return (
    <div className="spinner_load">
      {/* <iframe src="https://embed.lottiefiles.com/animation/39437"></iframe> */}
      <LoaderComponent />
    </div>
  );
}

export default Spinner;
